module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (157).4cc8462a.jpg";